/**
 * Single source of truth for design tokens shared between the MUI theme (React)
 * and the legacy SASS/CSS pipeline.
 *
 * Token values live in design-tokens.json so they can be imported directly by
 * both Node.js scripts (without a TS transpiler) and TypeScript consumers.
 *
 * These values are consumed by:
 *   - theme.ts (MUI theme configuration)
 *   - scripts/generate-tokens.mjs (generates design-tokens.css with CSS custom properties)
 *
 * Token naming follows a <category>-<role>[-<variant>] pattern so generated CSS
 * custom properties are predictable: e.g. --color-primary → colors.primary.main
 */

import tokens from './design-tokens.json';

export const {
  colors,
  colorGroups,
  paletteColors,
  spacing,
  borderRadius,
  shadows,
} = tokens;

export type DesignTokenColors = typeof colors;
export type DesignTokenSpacing = typeof spacing;
export type DesignTokenBorderRadius = typeof borderRadius;
export type DesignTokenShadows = typeof shadows;
